import tippy from 'tippy.js';

var els = document.querySelectorAll('.js-share-enabled'),
  i;
var template = document.getElementsByClassName('wbkn-social-buttons--sharing');

for (i = 0; i < els.length; ++i) {
  var text = '';

  // Get the quote Text.
  var quote = els[i].querySelector('p');

  // Get the cite Text.
  var cite = els[i].querySelector('cite');

  // Prepare final Quote text.
  if (quote) {
    text += '"' + quote.textContent + '"';
  }

  // Prepare cite Quote text.
  if (cite) {
    text += ' — ' + decodeURIComponent(cite.textContent);
  }

  // Replace the placeholder in URLS with the text.
  var final_content = template[0].innerHTML.replace(
    /##_TEXT_##/g,
    encodeURIComponent(text),
  );

  // Initialize tooltip functionality.
  tippy(els[i], {
    content: final_content,
    allowHTML: true,
    interactive: true,
  });
}
